import { yupResolver } from '@hookform/resolvers/yup'
import moment from 'moment'
import React from 'react'
import { useFieldArray, useForm, FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'
import * as yup from 'yup'

import Button from '../../../App/Components/Button/Button'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import { IHIInvoiceLine } from '../../interfaces/IHealthInsurance'
import { ErrorMessage } from '../../style'

import { TableHead } from './components/TableHead/TableHead'
import { TableRow } from './components/TableRow/TableRow'
import { StyledTable, StyledTableBody } from './style'

type Props = {
  onSaveTable: (lines: IHIInvoiceLine[]) => void
  defaultLines?: IHIInvoiceLine[]
}

const defaultInvoiceLine = {
  treatmentDate: moment().format('DD-MM-YYYY'),
  amount: 1,
  unitPrice: 0,
  unitPriceExcl: 0,
  discount: 0,
  vatPercentage: 21,
  lineTotal: 0,
  treatmentName: '',
  treatmentCode: '',
  personName: '',
  personAgbCode: '',
}

const schema = yup.object().shape({
  lines: yup
    .array()
    .min(1)
    .of(
      yup.object({
        id: yup.string(),
        personUuid: yup.string().required(),
        personAgbCode: yup.string().required(),
        treatmentName: yup.string().required(),
        treatmentCode: yup.string().required(),
        amount: yup.number().positive().required(),
        unitPrice: yup.number().positive().required(),
        discount: yup.number().positive().min(0).max(100).required(),
        vatPercentage: yup.number().positive().min(0).required(),
        lineTotal: yup.number().required(),
        treatmentDate: yup.string().required(),
      }),
    )
    .required(),
})

export const HITable = ({
  onSaveTable,
  defaultLines = [{ id: uuid(), ...defaultInvoiceLine }],
}: Props) => {
  const { t } = useTranslation()

  const formMethods = useForm<{ lines: IHIInvoiceLine[] }>({
    resolver: yupResolver(schema),
    defaultValues: { lines: defaultLines },
  })
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = formMethods

  const { append, remove, fields } = useFieldArray({ control, name: 'lines' })

  const { users, activityWithCode, healthInsuranceCustomerDetails } =
    useAppSelector(state => {
      return {
        users: state.users.list,
        activityWithCode: state.activities.activityWithCode,
        healthInsuranceCustomerDetails: state.healthInsurance.customerDetails,
      }
    })

  const handleAddLine = () =>
    append({
      id: uuid(),
      ...defaultInvoiceLine,
    })

  const deleteInvoiceLine = (index: number) => remove(index)

  return (
    <FormProvider {...formMethods}>
      {errors?.lines?.type === 'min' ? (
        <ErrorMessage>{t('At least 1 item should be added')}</ErrorMessage>
      ) : null}
      <div>
        <StyledTable>
          <TableHead />
          <StyledTableBody>
            {fields.map((lineMap, index: number) => {
              return (
                <TableRow
                  key={lineMap.id}
                  index={index}
                  users={users}
                  activityList={activityWithCode.list}
                  onDelete={deleteInvoiceLine}
                />
              )
            })}
            {/* <Total lines={lines} />*/}
          </StyledTableBody>
        </StyledTable>
        <Button onClick={handleAddLine}>{t('Add item')}</Button>
        <Button
          onClick={handleSubmit(
            async data => onSaveTable(data.lines),
            formErrors => console.log(formErrors, 'ERRORLOG'),
          )}>
          {t('Create health insurance')}
        </Button>
      </div>
    </FormProvider>
  )
}
